var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPretentionChartLine2 = function SvgPretentionChartLine2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 1.667V11.75c0 1.584-.833 2.417-2.417 2.417H4.917c-1.584 0-2.417-.833-2.417-2.417V1.667z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 2.292H1.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h16.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625M13.892 18.617a.63.63 0 0 1-.559.342.6.6 0 0 1-.275-.067L10 17.367l-3.058 1.525a.6.6 0 0 1-.275.067.63.63 0 0 1-.559-.342.617.617 0 0 1 .284-.842l2.983-1.491v-2.117h1.25v2.117l2.983 1.491c.317.15.442.525.284.842M6.25 9.792a.624.624 0 0 1-.4-1.108l2.625-2.192c.242-.2.55-.283.842-.233.3.05.558.233.716.5l.875 1.458 2.442-2.033a.624.624 0 0 1 .883.083.624.624 0 0 1-.083.883l-2.625 2.192c-.242.2-.55.283-.842.233-.3-.05-.558-.233-.716-.5l-.875-1.458L6.65 9.65a.65.65 0 0 1-.4.142"
  })));
};
export default SvgPretentionChartLine2;